
  import {Member} from '../models/TeamMember'
  import axios from "../api/axios";
  import {TEAM_URL} from "../utils/constants";
  
  export async function getTeamMembersService(): Promise<Member[]> {
      const response = await axios.get(TEAM_URL);
      return response.data;
  }
  